import React, {PropsWithChildren, useContext, useState} from "react";
import {ServerDataContext} from "./ServerDataContext";
import {AddOnItemSection} from "../models/item.model";

interface AddOnItemsContextState {
    addOnItemSection: AddOnItemSection;
}

export const AddOnItemsContext = React.createContext({} as AddOnItemsContextState);

export const AddOnItemsProvider: React.FunctionComponent<PropsWithChildren> = ({children}) => {
    const data = useContext(ServerDataContext);

    return (
        <AddOnItemsContext.Provider
            value={{addOnItemSection: data.addOnItemSection}}>
            {children}
        </AddOnItemsContext.Provider>
    )
}